import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  keywords?: string;
  type?: "website" | "article";
  jsonLd?: object | object[];
}

const SEO = ({
  title = "Conclase: Tech Recruiting | Tech Training | Tech Start-up Studio",
  description = "Conclase builds Africa's technology workforce and delivery capacity. Hire pre-vetted tech talent in 24–48 hours, launch software projects, manage your tech operations, or upskill your team.",
  image = "https://conclaseint.com/og-image.png",
  url = "https://conclaseint.com/",
  keywords = "tech recruiting Africa, hire tech talent Nigeria, software development Africa, managed technology services, corporate tech training, tech startup studio, Conclase",
  type = "website",
  jsonLd,
}: SEOProps) => {
  const schemas = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];

  return (
    <Helmet>
      {/* Basic */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Conclase" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Conclase" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@conclasehq" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Page-specific JSON-LD */}
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
